import PageHeaderRoot from './PageHeaderRoot';
import PageSummary from './PageSummary';

const PageHeaderCommunity = () => {
  return <PageHeaderRoot variant="communityIndex" afterCol={<PageSummary variant="h4" />} />;
};

export default PageHeaderCommunity;
